<div class="modal-content" [ngClass]="currentTheme">
  <div class="modal-header">
    <h3 class="modal-title">Download File</h3>
    <div class="header-actions">
      <i
        (click)="close()"
        class="fa fa-times"
        style="cursor: pointer;"
        role="button"
        tabindex="0"
        (keyup.enter)="close()"
        aria-label="Close"
      ></i>
    </div>
  </div>

  <div
    class="modal-body"
    [style.backgroundColor]="currentTheme === 'theme-black' ? '#423d40' : 'white'"
  >
    <div class="w-100 text-center download-container">
      @if (downloading) {
<span>
        <i class="fa fa-spinner fa-spin color-white fa-2x"></i>
      </span>
}

      @if (systemGeneratedRequest) {
<span
       
        class="system-message"
        [style.color]="currentTheme === 'theme-black' ? 'white' : '#0d0d0d'"
      >
        {{ downloadMessage }}
      </span>
}

      @if (!downloading && !systemGeneratedRequest) {
<button
       
        class="save-button download-action"
        type="button"
        (click)="downloadFile()"
      >
        Download
      </button>
}
    </div>
  </div>
</div>
